"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import InfoIcon from "@mui/icons-material/Info";
import ErrorIcon from '@mui/icons-material/Error';
import AnnouncementIcon from '@mui/icons-material/Announcement';

import color from "@/style/theme/Color";
import { displayDate } from "@/utils/dateDisplay";
import { NotifikasiReceipt } from "@/types/shared.types";
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

import { useState } from "react";

interface NotificationCardProps {
  notification: NotifikasiReceipt;
}

const NotificationIconMap = {
  "Pengumuman": AnnouncementIcon,
  "Informasi": InfoIcon,
  "Peringatan": ErrorIcon,
  "Info": InfoIcon,
  "Pengingat": ErrorIcon
};

const NotificationCard = ({ notification: defaultNotification }: NotificationCardProps) => {
  const [notification, setNotification] = useState<NotifikasiReceipt>(defaultNotification);

  const NotificationIcon = NotificationIconMap[notification.content.type] || InfoIcon;

  const handleReadClick = async () => {
    if (notification.isRead) {
      return;
    }
    fetch(`${process.env.NEXT_PUBLIC_API_URL}/v2/notifikasi/${notification.id}/read`, {
      method: "PATCH"
    });
    setNotification({
      ...notification,
      isRead: true
    });
  };

  return <MenuItem
    sx={{
      display: "block",
      whiteSpace: "normal",
      fontSize: "0.9rem",
      borderBottom: "1px solid #E0E0E0",
      ':first-child': {
        borderTop: "1px solid #E0E0E0"
      },
      paddingBottom: 1.5,
      paddingTop: 1.5,
      backgroundColor: notification.isRead ? "rgba(0, 0, 0, 0.04)" : undefined
    }}
    onClick={handleReadClick}
  >
    <Box
      sx={{
        display: "flex",
        marginBottom: 1,
        fontSize: "0.8rem",
        alignItems: "center",
        gap: 0.5
      }}>
      <NotificationIcon
        sx={{
          width: "1rem",
          height: "1rem"
        }}/>

      <Typography
        sx={{
          marginRight: 'auto',
          fontSize: 'inherit'
        }}>{notification.content.type}</Typography>
      <Typography
        sx={{
          fontSize: 'inherit'
        }}>{displayDate(notification.content.date)}</Typography>
      {notification.isRead ?
        <CircleOutlinedIcon
          sx={{
            width: "0.8rem",
            height: "0.8rem"
          }}/> :
        <CircleIcon
          sx={{
            width: "0.8rem",
            height: "0.8rem",
            color: color.primary
          }}/>}
    </Box>
    <Typography
      sx={{
        fontWeight: "bold",
        marginBottom: 1,
        fontSize: 'inherit'
      }}>{notification.content.title}</Typography>
    <Typography
      sx={{
        fontSize: 'inherit'
      }}>{notification.content.body}</Typography>
  </MenuItem>;
};

export default NotificationCard;
